import validateDate from 'validate-date';

class DateValidatorAdapter {
    isValid (date) {
        return validateDate(date, "boolean", "dd/mm/yyyy")
    }
}

export default DateValidatorAdapter;
